import { render } from "./Saida.vue?vue&type=template&id=1f47e622&scoped=true"
import script from "./Saida.vue?vue&type=script&lang=js"
export * from "./Saida.vue?vue&type=script&lang=js"

import "./Saida.vue?vue&type=style&index=0&id=1f47e622&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f47e622"]])

export default __exports__